import { compact } from '@lglp/utils';
import { prop } from 'ramda';

import { DocumentType } from '../../../../types/document';
import { processFinancialFooter } from './financial/financial-footer';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicFinancialPublication
 */

/**
 * @typedef {DocumentSchema} FinancialPublicationSchema
 */

/**
 * Transform the given input into objects
 *
 * @param  {PrismicFinancialPublication} data
 * @return {FinancialPublicationSchema}
 */
const processFinancialPublication = (data) =>
  compact({
    uid: DocumentType.FINANCIAL_PUBLICATION,
    type: DocumentType.FINANCIAL_PUBLICATION,
    ...processFinancialFooter(data),
  });

/**
 * Normalizr schema representing a financial publication page
 */
export const FinancialPublicationEntity = deprecatedPageEntity(
  DocumentType.FINANCIAL_PUBLICATION,
  {
    processStrategy: (entity) => ({
      ...processFinancialPublication(prop('data', entity)),
    }),
  }
);
